import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const CONSENT_RADIUS_PX = 8;

const useStyles = makeStyles({ name: 'AgreementAccordion' })(
  ({ palette, spacing, typography }) => ({
    root: {
      backgroundColor: 'transparent',
      backgroundImage: 'none',
      boxShadow: 'none',
      color: palette.semantic.text.primary,
      borderBottom: `${pxToRem(1)} solid ${palette.semantic.border.secondary}`,
      '&::before': {
        display: 'none',
      },
      '&:first-of-type': {
        borderTop: `${pxToRem(1)} solid ${palette.semantic.border.secondary}`,
      },
    },
    summary: {
      gap: spacing(0),
      minHeight: 'unset',
      padding: `${spacing(1)} 0`,
      '&.Mui-expanded': {
        minHeight: 'unset',
        paddingBottom: 0,
      },
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: 'transparent',
      },
      '&.Mui-focusVisible': {
        outline: `${pxToRem(2)} solid ${palette.semantic.input.borderFocus}`,
      },
      '& .MuiAccordionSummary-content': {
        alignItems: 'center',
        gap: spacing(0),
        margin: 0,
      },
      '& .MuiAccordionSummary-expandIconWrapper': {
        color: palette.semantic.icon.primary,
      },
    },
    agreedIcon: {
      color: palette.semantic.text.accentGreen,
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      padding: `${spacing(2)} 0 ${spacing(1)}`,
    },
    terms: {
      ...typography.bodySm,
      '& p': {
        margin: 0,
      },
      '& > p:not(:last-child)': {
        marginBottom: '1.4em',
      },
      '& ol': {
        margin: 0,
        paddingLeft: '1.5em',
        listStyleType: 'decimal',
      },
      '& ol ol': {
        listStyleType: 'lower-alpha',
      },
      '& ol ol ol': {
        listStyleType: 'lower-roman',
      },
    },
    consent: {
      alignItems: 'flex-start',
      gap: spacing(-1),
      margin: 0,
      padding: `${spacing(1)} ${spacing(0)}`,
      backgroundColor: palette.semantic.bg.layer1,
      border: `${pxToRem(1)} solid ${palette.semantic.input.borderDefault}`,
      borderRadius: pxToRem(CONSENT_RADIUS_PX),
    },
    checkbox: {
      padding: 0,
      color: palette.semantic.icon.primary,
      '&.Mui-checked': {
        color: palette.semantic.icon.primary,
      },
    },
  })
);

export default useStyles;
